export interface Props {
  items: {
    name: string
    to?: string
    active?: boolean
  }[]
}

export const useTab = (props: Props) => {
  const { items } = props

  return {
    items,
  }
}
